import { gbp } from "../lib/format";

export function KpiCard({ label, hint, value, display, accent, testid, delay = 0, tone }) {
  const color = tone === "neg" ? "text-primary" : tone === "pos" ? "text-[hsl(var(--positive))]" : "";
  return (
    <div className={`rise relative overflow-hidden rounded-lg border bg-card p-5 md:p-6 ${accent ? "ring-1 ring-primary/40" : ""}`}
      style={{ animationDelay: `${delay}ms` }} data-testid={testid}>
      {accent && <span className="absolute inset-x-0 top-0 h-1 bg-primary" />}
      <div className="eyebrow">{label}</div>
      <div key={String(value)} className={`flash mt-3 font-heading text-2xl md:text-[1.75rem] font-bold tracking-tight font-figure ${color}`} data-testid={`${testid}-value`}>
        {display ?? gbp(value)}
      </div>
      {hint && <div className="mt-2 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
